import { withStyles } from "@material-ui/core";

const styles = (theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    marginTop: 8,
    marginBottom: 8,
  },
  rowLabel: {
    fontSize: theme.textFontSize,
    color: theme.dispatchPanelHeaderColor,
    minWidth: "30%",
    marginRight: 8,
  },
  inputContainer: {
    width: "100%",
  },
  readOnlyValue: {
    fontSize: theme.textFontSize,
    color: theme.gridTextColor,
    wordBreak: "break-word",
  },
});

const WithRowLabel = (WrappedComponent) =>
  withStyles(styles)(
    ({
      classes,
      label,
      labelClass,
      inputClass,
      isReadOnly,
      value,
      containerClass,
      ...otherProps
    }) => (
      <div className={`${classes.container} ${containerClass ?? ""}`}>
        <div className={`${classes.rowLabel} ${labelClass ?? ""}`}>{label}</div>
        <div className={inputClass ?? classes.inputContainer}>
          {isReadOnly ? (
            <span className= {classes.readOnlyValue}>{value}</span>
          ) : (
            <WrappedComponent value={value} {...otherProps} />
          )}
        </div>
      </div>
    )
  );

export default WithRowLabel;
